import { ApplyForm } from "@features/apply-membership";
import { BaseLayout } from "@layouts/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_authenticated/apply/")({
  component: ApplyPage,
});

function ApplyPage() {
  const { t } = useTranslation();

  return (
    <BaseLayout>
      <div className="px-6 py-8 lg:py-[60px] max-w-5xl mx-auto">
        <h1 className="text-title4">{t("apply.pageTitle")}</h1>
        <p className="text-body3 mt-3 rounded-4 border border-blue-500 bg-gray-10 p-2">
          💡 {t("apply.onlyEnglishDescription")}
        </p>
        <ApplyForm />
      </div>
    </BaseLayout>
  );
}
